export default {
  notFound: {
    seo: {
      title: 'Page Not Found',
    },
    badge: 'Error 404',
    title: "You've gone off route",
    description:
      "This URL isn't on our map. Double-check the link, or head back to a known stop — we'll get you moving again.",
    requestedPathLabel: 'Requested path',
    backHome: 'Back to home',
    contactUs: 'Contact us',
    pricing: 'Pricing',
    tagline: 'Geofleet · Last-mile & fleet ops',
  },
};
